<app-notify-message></app-notify-message>
<app-reports-header></app-reports-header>
<div class="row no-gutters reports-page">
  <div class="col-md-2 col-sm-0 p-0">
    <app-reports-side-menu></app-reports-side-menu>
  </div>
  <div class="reports-body col-md-10 col-sm-12 p-0">
    <div class="row no-gutters action-row align-items-center px-2">
      <div class="col-md-3">
        <h4 class="report-heading page-heading"><i class="fa fa-bar-chart"></i> Billing</h4>
      </div>
      <div class="col-md-9 text-right">
        <!-- <div class="btn-group">
          <button class="btn btn-custom btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Showing for last {{selectedMonth.text}}
          </button>
          <div class="dropdown-menu">
            <a class="dropdown-item" (click)="onMonthsChange(1)">Last Month</a>
            <a class="dropdown-item" (click)="onMonthsChange(3)">Past 3 Months</a>
            <a class="dropdown-item" (click)="onMonthsChange(6)">Past 6 Months</a>
            <a class="dropdown-item" (click)="onMonthsChange(12)">Past 12 Months</a>
          </div>
        </div> -->
        <button
          class="btn btn-icon btn-sm ml-2 refresh"
          (click)="refresh()"
          ngbTooltip="Refresh"
          placement="top"
          [disabled]="isLoading">
          <i class="fa fa-refresh" aria-hidden="true"></i>
          <span class="mob-access-text d-none">&nbsp;Refresh</span>
        </button>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-md-12">
        <div class="row no-gutters mt-2 px-2">
          <div class="col-md-12 billing-widget-header bottom-border">
            <h6>
              Last Month Data
              <span style="font-weight: 400;">(From {{oneMonthData.startDate}} to {{oneMonthData.endDate}})</span>
            </h6>
          </div>
          <div class="col-md-5 col-sm-12 right-border">
            <div class="billing-widget-wrapper bottom-left-border">
              <h6 style="text-transform: capitalize;">Devices</h6>
              <canvas id="horizontalBar" height="130" role="img"></canvas>
            </div>
          </div>
          <div class="col-md-7 col-sm-12">
            <div class="billing-widget-wrapper bottom-right-border">
              <h6 style="text-transform: capitalize;">Details</h6>
              <div class="chart-container">
                <canvas id="doughnutChart" height="230" role="img"></canvas>
              </div>
              <div class="table-container">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Devices</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><div class="color-box strigger"></div> S Triggers</td>
                      <td>{{display_counts.sTrigger}}</td>
                      <td>Rs. {{display_prices.sTrigger}}</td>
                    </tr>
                    <tr>
                      <td><div class="color-box ctrigger"></div> C Triggers</td>
                      <td>{{display_counts.cTrigger}}</td>
                      <td>Rs. {{display_prices.cTrigger}}</td>
                    </tr>
                    <tr>
                      <td><div class="color-box cCumtrigger"></div> C Triggers Cumulative</td>
                      <td>{{display_counts.cCumulative}}</td>
                      <td>Rs. {{display_prices.cCumulative}}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td class="text-right text-bold">Total: </td>
                      <td class="text-bold">Rs. {{display_prices.total}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row no-gutters">
          <div class="col-md-4 col-sm-12 p-2">
            <div class="billing-widget-wrapper">
              <div class="outer-wrapper">
                <div class="total-count-container">
                  <span class="text">Total Devices</span>
                  <h2 class="count">{{totalCounts.total}}</h2>
                </div>
                <div class="category-count-container">
                  <span class="strigger-wrapper">
                    <span class="text">S Trigger Count</span>
                    <h5 class="count">{{totalCounts.sTrigger}}</h5>
                  </span>
                  <span class="ctrigger-wrapper">
                    <span class="text">C Trigger Count</span>
                    <h5 class="count">{{totalCounts.cTrigger}}</h5>
                  </span>
                  <span class="cumulative-wrapper">
                    <span class="text">C Cumulative Count</span>
                    <h5 class="count">{{totalCounts.cCumulative}}</h5>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12 p-2">
            <div class="billing-widget-wrapper">
              <div class="outer-wrapper">
                <div class="total-count-container">
                  <span class="text">Total Price</span>
                  <h2 class="count">&#8377; {{display_totalPrices.total}}</h2>
                </div>
                <div class="category-count-container">
                  <span class="strigger-wrapper">
                    <span class="text">S Trigger Cost</span>
                    <h5 class="count">{{display_totalPrices.sTrigger}}</h5>
                  </span>
                  <span class="ctrigger-wrapper">
                    <span class="text">C Trigger Cost</span>
                    <h5 class="count">{{display_totalPrices.cTrigger}}</h5>
                  </span>
                  <span class="cumulative-wrapper">
                    <span class="text">C Cumulative Cost</span>
                    <h5 class="count">{{display_totalPrices.cCumulative}}</h5>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12 p-2">
            <div class="billing-widget-wrapper">
              <canvas id="doughnutChart" height="170" role="img"></canvas>
            </div>
          </div>
        </div> -->
        <div class="row no-gutters my-2 px-2">
          <div class="col-md-12 billing-widget-header bottom-border">
            <h6 class="d-inline-block">
              Historical
              <span style="font-weight: 400; font-size: 12px;">(Click on the respective bar to download the bill for that month)</span>
            </h6>
            <div class="dropdown d-inline-block pull-right">
              <a class="btn-sm dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Showing for last {{selectedMonth.text}}
              </a>
              <div class="dropdown-menu">
                <!-- <a class="dropdown-item" (click)="onMonthsChange(1)">Last Month</a> -->
                <a class="dropdown-item" (click)="onMonthsChange(3)">Past 3 Months</a>
                <a class="dropdown-item" (click)="onMonthsChange(6)">Past 6 Months</a>
                <a class="dropdown-item" (click)="onMonthsChange(12)">Past 12 Months</a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12 right-border">
            <div class="billing-widget-wrapper lg bottom-left-border">
              <h6 style="text-transform: capitalize;">Devices</h6>
              <canvas id="barChart" height="160" role="img"></canvas>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="billing-widget-wrapper lg bottom-right-border">
              <h6 style="text-transform: capitalize;">Cost</h6>
              <canvas id="lineChart" height="160" role="img"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
